import {Component, Input} from '@angular/core';
import {CatalogRecord} from '@raven';

@Component({
  selector: 'rn-book-carousel',
  template: `
    <rn-carousel [title]="title">
      <!-- Must track by $index because catalogRecords could contain duplicate records. -->
      @for (catalogRecord of catalogRecords; track $index) {
        <div class="carousel-item" *carouselItem [ngClass]="{ 'last' : $last }">
          <rn-grid-item [catalogRecord]="catalogRecord"/>
        </div>
      }
      <ng-template #emptyTemplate>
        <div class="empty-content flex-col flex-center-center">
          <h1 style="margin: auto auto">Check back later for more titles</h1>
        </div>
      </ng-template>
    </rn-carousel>
  `,
  styleUrl: './book-carousel.component.scss',
  standalone: false
})
export class BookCarouselComponent {
  @Input() title = '';
  @Input() catalogRecords: CatalogRecord[];
}
